// Types
import { RequestParams, ApiOptions } from './types'

// Utilities
import { store } from '../cookies'

export default class Api {

  options: ApiOptions

  constructor(options: ApiOptions) {
    this.options = options
  }

  serializeParams = (
    params: RequestParams
  ): string => {
    if(!params || typeof params === 'string') return ''

    let paramArr = []

    if(!Array.isArray(params)) {
      for (var p in params) {
        paramArr.push(encodeURIComponent(p) + "=" + encodeURIComponent(params[p]))
      }
    }

    return paramArr.join("&");
  }

  request = async (url: string, params: any = null, options: RequestInit = {}) => {

    if(options.method === 'GET' || options.method === 'DELETE') {
      const queryString = this.serializeParams(params)
      url += url.indexOf('?') ? queryString : '?' + queryString
    } else {
      options.body = JSON.stringify(params ? params : {})
    }

    options.headers = new Headers({
      'Content-Type': 'application/json',
      'Content-Length': `${typeof options.body === 'string' ? options.body.length : 0}`,
      ...options.headers
    })

    const token = store.get(this.options.tokenName)
    if(token && typeof token === 'string') {
      options.headers.append(this.options.tokenName, token)
    }

    const response = await fetch(this.options.host + url, options)

    const responseBody = await response.json()

    if(response.status !== 200) {
      throw Error(responseBody || response.statusText)
    }

    return responseBody || null

  }

  get = (
    url: string,
    params: any = null,
    options: RequestInit = {}
  ) => this.request(url, params, { method: 'GET' , ...options })

  post = (
    url: string,
    params: any = null,
    options: RequestInit = {}
  ) => this.request(url, params, { method: 'POST' , ...options })

  put = (
    url: string,
    params: any = null,
    options: RequestInit = {}
  ) => this.request(url, params, { method: 'PUT' , ...options })

  patch = (
    url: string,
    params: any = null,
    options: RequestInit = {}
  ) => this.request(url, params, { method: 'PATCH' , ...options })

  delete = (
    url: string,
    params: any = null,
    options: RequestInit = {}
  ) => this.request(url, params, { method: 'DELETE', ...options })

}
